import { useMediaQuery } from "./useMediaQuery";

export type MotionPolicy = { reduced: boolean; ambientFactor: number; transitionFactor: number };

export function useMotionPolicy(): MotionPolicy {
  const reduced = useMediaQuery("(prefers-reduced-motion: reduce)");
  return reduced
    ? { reduced: true, ambientFactor: 0, transitionFactor: 0 }
    : { reduced: false, ambientFactor: 1, transitionFactor: 1 };
}
